import 'react-native-gesture-handler';
import { AppRegistry } from 'react-native';
import { App } from '../src/App';
import { name as appName } from '../app.json';
import '../src/theme/global.css';

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
